<template>
<div class="file-upload" >
  <spinner v-if="loading" ></spinner>
  <dashboard 
    :uppy="uppy" 
    :props="{
      direction: hebrew ? 'rtl' : 'ltr',
      height: 450,
      showRemoveButtonAfterComplete: true,
      note:  hebrew ? 'ניתן להעלות קבצי zip, txt' : 'zip and txt files',
      proudlyDisplayPoweredByUppy: false
    }"
    />

  <div class="bg-white text-muted text-center position-absolute w-100" style="bottom:0">
  <small v-if="hebrew">
    Powered by <a href="https://uppy.io/" target="_blank">Uppy</a>
  </small>
  <small v-else>
  בחסות 
  <a href="https://uppy.io/" target="_blank">Uppy</a>
  </small>
  <p>
  {{hebrew ? 'תהליך עיבוד הקבצים עשוי לקחת זמן. כאשר התהליך יסתיים, תקבלו על כך הודעה בדוא"ל' :
    'The analysis process may take a while, when it is complete you will be notified by email.'
  }}
  </p>
  </div> 
</div>
</template>

<script>
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import Uppy from '@uppy/core'
import GoldenRetriever from '@uppy/golden-retriever'
import '@uppy/golden-retriever/lib/ServiceWorker'
//import {DashboardModal} from '@uppy/vue'
import { Dashboard } from '@uppy/vue'
import hebrewLocale from '@uppy/locales/lib/he_IL'
import Tus from '@uppy/tus'
import Spinner from "@/components/spinner"
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('./sw.js')
}
export default {
  name: "UploadFiles",
  components: { Dashboard, Spinner },
  data() {
    return {
      loading: false
    }
  },
  mounted () {     
    if (this.uploadedFiles.length > 0) { //restore files if exist
      this.uppy.setState(this.$store.state.uppyState)
    }
  },
  methods: {
    setLoadingTrue () {
      this.loading = true
    },
    setLoadingFalse () {
      this.loading = false
    },
    uploadCompleted (results) {
      this.loading = false
      if (results.successful.length === 0)
        return
      this.showUppy = false
      //console.log('Uploaded: ' + results.successful.map(file => file.name + ': ' + file.uploadURL).join (', '))      
      this.$store.commit('UPDATE_URL_LIST',  results.successful.map(file => file.uploadURL).join (',').split(','))
      //window.alert('Upload done. See console for details.')
      this.$emit('upload-complete')
      this.$store.commit('MORPH_NOT_RUN')      
    },
    sendDeleteRequestForFile(file) {
      let newFileList = this.uploadedFiles.filter( item => item  !== file.uploadURL )
      this.$store.commit('SET_URL_LIST', newFileList)
      if (this.uploadedFiles.length == 0)
        this.loading = false
    },
  },

  computed: {
    hebrew () {
      return this.$settings.hebrew
    },    
    uppy () {
      return new Uppy({
        locale: this.$settings.hebrew ? hebrewLocale : null,
        autoProceed: true,
        restrictions: {
          maxFileSize: 400000000,
          allowedFileTypes: ['.txt', '.zip']
        }
      })
      .on('file-removed', (file, reason) => {
        if (reason === 'removed-by-user') {
            this.sendDeleteRequestForFile(file)
          }
        })
      .use(Tus, {
        endpoint: 'https://upload.loadbalancer.dicta.org.il/files/'
      })
      .use(GoldenRetriever, { serviceWorker: true })
      .on('cancel-all', this.setLoadingFalse)
      .on('upload', this.setLoadingTrue)
      .on('restored', this.uploading)
      .on('complete', this.uploadCompleted)
      
    },
    uploadedFiles () {
      return this.$store.state.urlList
    }    
  },
   beforeDestroy () {
    this.$store.commit('SAVE_UPPY_STATE', this.uppy.getState())
    this.uppy.close()
  }
}
</script>
<style lang="scss">
  .uppy-Dashboard-inner {
    background: transparent!important;
    border: none!important;
    font-family: 'Arimo';
  }
  .uppy-Dashboard-AddFiles {
    border: none!important;
  }
  .uppy-StatusBar,
  .uppy-StatusBar-actions {
    display: none;
  }
  .uppy-Dashboard-Item-progressIndicator {
    display: none;
  }  
  .uppy-Dashboard-AddFiles-title {
    position: relative;
    z-index: 1;
  }
  .uppy-Dashboard-AddFiles-info {
    padding-top: 0;
    height: calc(49% - 14px);       
  }
</style>